/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { getTaskByType } from "../../utils/task";
import Modal, { ModalHeader } from "../Modal";
import SearchEmployee from "../Employee/SearchEmployee";
import Icon from "../Icon";
import { get } from "lodash";
import { Col, Row } from "../ContentLayout";
import DataComponent from "../DataComponent";
import Button from "../Button";
import { getDay } from "../../utils/date";
// import systemAlert from "../../utils/systemAlert";

const employeeTitle = (tasks) => {
  const task = getTaskByType('approval_handover_request')
  let title = <></>
  if (!tasks) {
    title = <>전체 할일</>
  } else if (tasks && tasks.length > 1) {
    title = <>할일 <span className='color-main-100'>{tasks.length}</span>건</>
  } else if (tasks.length === 1) {
    const _target = getTaskByType(get(tasks, '[0].approvalTarget.type'))
    const requestEmployeeName = get(tasks, '[0].approvalTarget.requesterEmployee.name')
    title = `${requestEmployeeName ? requestEmployeeName + '님의' : ''} ${_target ? _target.label : ''}`
  }
  return <><Icon src={task.icon} /> {title} 위임</>
}

const TaskHandoverPopup = (props) => {
  const {
    isOpen,
    close,
    taskSelectedList,
    employeeSelectedList,
    setEmployeeSelectedList,
    submit
  } = props

  const [handoverReason, setHandoverReason] = useState("");
  const [date] = useState([getDay(), getDay(-5)]);

  const _submit = () => {
    if (submit) {
      submit({ date, handoverReason, taskSelectedList, employeeSelectedList })
    }
  }

  const _close = () => {
    close()
    setHandoverReason("")
  }


  return (
    <Modal
      size="lg"
      isOpen={!!isOpen}
      close={_close}
      className="task-handover-modal"
    >
      <ModalHeader className="task-handover-modal-header">
        {employeeTitle(taskSelectedList)}
      </ModalHeader>
      <Row>
        <Col sm={8} style={{
          borderRight: '1px solid #F1F4F8'
        }}>
          <h4>
            위임대상 선택 <span className="color-red-100">*</span>
          </h4>
          <SearchEmployee
            selectedList={employeeSelectedList}
            setSelectedList={setEmployeeSelectedList}
            isSingle={true}
          ></SearchEmployee>
        </Col>
        <Col sm={8} className="task-handover-modal-right">
          {/* 
          <h4>
            위임 기간
          </h4>
          <div className="task-handover-modal-content">
            <DataComponent
              field={{
                type: 'datepicker',
                key: 'date',
                options: {
                  mode: "range",
                  dateFormat: "Y-m-d",
                },
                defaultValue: date,
                required: true,
              }}
              onChange={(e) => {
                setDate(e.date)
              }}
            ></DataComponent>
          </div> 
          */}
          <h4>
            사유
          </h4>
          <div className="task-handover-modal-content">
            <DataComponent
              field={{ type: 'textarea', label: '사유' }}
              value={handoverReason}
              onChange={(e) => setHandoverReason(e.target.value)}
            ></DataComponent>
          </div>
          <div className="task-handover-modal-button-wrap">
            <Button onClick={_close} color={'text'}>취소</Button>
            <Button onClick={_submit}>위임요청</Button>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default TaskHandoverPopup;
